"use client";

import { toast } from "sonner";

import type { Notification } from "../../lib/types";
import { NotificationToastItem } from "./item";

interface ShowNotificationToastOptions {
  duration?: number;
}

export function showNotificationToast(
  notification: Notification,
  options?: ShowNotificationToastOptions,
) {
  const duration = options?.duration ?? 5000;

  return toast.custom(
    (toastId) => (
      <NotificationToastItem
        notification={notification}
        toastId={toastId}
        onDismiss={toast.dismiss}
      />
    ),
    {
      // Stable id so the same notification can never stack two toasts —
      // Sonner updates the existing toast instead of adding a new one if
      // the event is somehow delivered twice.
      id: notification.id ? `notif-${notification.id}` : undefined,
      duration,
      unstyled: true,
      position: "top-center",
    },
  );
}
